import { SimpleGrid } from "@chakra-ui/react";

import { RequestContractFormProps } from "forms/RequestContractForm";
import { formatDate } from "util/statHelpers";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import BasicInfoStat from "./BasicInfoStat";

const CONTRACT_STAT_COLUMNS = mobileStyleBreakpoint(2, 4);

const BasicInfoStats = ({
  formData,
  uom,
}: {
  formData: RequestContractFormProps;
  uom?: string;
}) => (
  <SimpleGrid columns={CONTRACT_STAT_COLUMNS} gap={0}>
    <BasicInfoStat label="Product" value={formData.product?.label} />
    <BasicInfoStat label="Quantity" value={`${formData.quantity} ${uom}`} />
    <BasicInfoStat
      label="Start Ship"
      value={formData.startShipDate ? formatDate(formData.startShipDate) : "-"}
    />
    <BasicInfoStat
      label="End Ship"
      value={formData.endShipDate ? formatDate(formData.endShipDate) : "-"}
    />
  </SimpleGrid>
);

export default BasicInfoStats;
